import "core-js/modules/es.array.push.js";
import { md5 } from "js-md5";
import { getUser } from "@/api/user";
import { UPDATE_USER } from "@/constants/user";
import { GLOBAL_MD5 } from "@/constants/auth";
import { getToken, removeToken } from "@/utils/auth";
const userModule = {
  state: {
    userInfo: {},
    token: null
  },
  mutations: {
    [UPDATE_USER](state, payload) {
      state.userInfo = payload;
    }
  },
  actions: {
    getUser({
      commit
    }) {
      return new Promise((resove, reject) => {
        getUser().then(msg => {
          const users = localStorage.getItem("users");
          const arrUsers = [];
          if (users) {
            try {
              arrUsers.push(...JSON.parse(users));
              // 如果这里没有抛出异常，说明是JSON格式
            } catch (e) {
              // 捕获到异常，说明不是JSON格式
              arrUsers.push(...JSON.parse(JSON.stringify(users)));
            }
          }
          const storageMsg = {
            token: getToken(),
            avatar: msg.data?.avatar,
            id: msg.data?.id,
            nickname: msg.data?.nickname
          };
          if (msg.code === 200) {
            resove();
            commit(UPDATE_USER, msg.data);
            if (users === null) {
              localStorage.setItem("users", JSON.stringify([storageMsg]));
            } else {
              const findIndex = arrUsers.findIndex(item => item.id === storageMsg.id);
              if (findIndex === -1) {
                arrUsers.push(storageMsg);
              } else {
                arrUsers.splice(findIndex, 1, storageMsg);
              }
              const aa = arrUsers.filter(item => {
                return item.id;
              });
              localStorage.setItem("users", JSON.stringify(aa));
            }
          } else {
            showFailToast("获取信息失败，请重新登录");
            const index = arrUsers.findIndex(item => {
              return item.token === getToken();
            });
            arrUsers.splice(index, 1);
            setTimeout(() => {
              localStorage.setItem("users", JSON.stringify(arrUsers));
              removeToken();
              location.reload();
            }, 1000);
          }
        });
      });
    },
    clearUser({
      commit
    }) {
      commit(UPDATE_USER, {});
    },
    cancelUser() {
      const users = localStorage.getItem("users");
      // console.log(users);
      if (users) {
        const usersNew = JSON.parse(users).filter(item => {
          return item.token !== getToken();
        });
        localStorage.setItem("users", JSON.stringify(usersNew));
      }
    }
  }
};
export default userModule;